import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics'
import { type Messaging } from 'firebase/messaging'
import { logWarn } from '@/lib/log'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

// 🎓 Master Class Blueprint: Singleton Firebase Instance
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)

// Features
export const analytics =
  typeof window !== 'undefined' ? isAnalyticsSupported().then(yes => (yes ? getAnalytics(app) : null)) : null

// 🔧 Messaging: Asenkron init — desteklenmeyen ortamlarda (Playwright, SSR, Safari Webview) Sentry hatalarını engeller
let messagingInstance: Messaging | null = null
let messagingInitPromise: Promise<Messaging | null> | null = null

export async function getMessagingInstance(): Promise<Messaging | null> {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return null
  if (messagingInstance) return messagingInstance
  if (messagingInitPromise) return messagingInitPromise

  messagingInitPromise = import('firebase/messaging').then(({ isSupported, getMessaging }) => {
    return isSupported().then(supported => {
      if (supported) {
        try {
          messagingInstance = getMessaging(app)
          return messagingInstance
        } catch (err) {
          logWarn('Firebase Messaging init failed:', err)
          return null
        }
      }
      return null
    }).catch(() => null)
  }).catch(() => null)

  return messagingInitPromise
}

export default app

